<ng-container *ngIf="control">
	<div
		*ngIf="type !== 'textarea'; else textArea"
		[class.c-input--error]="hasErrors()"
		[class.c-input--rtl]="!ltr && (type === 'number' || type === 'price')"
		[class.c-input--value]="hasValue()"
		[class.c-input--with-unit]="hasUnit()"
		class="c-input"
	>
		<input
			(blur)="blur()"
			(focusin)="focusIn()"
			(keypress)="input($event)"
			[formControl]="control"
			[max]="max ?? null"
			[maxlength]="maxChar || null"
			[min]="min ?? null"
			[name]="name"
			[placeholder]="type === 'price' ? '-,--' : ''"
			[style.padding-left]="prefix && prefixElement ? 8 + prefixElement.nativeElement.clientWidth + 'px !important' : ''"
			[type]="type === 'price' ? 'number' : type"
			data-1p-ignore
		/>
		<label *ngIf="label" [for]="name">
			{{ label }}

			<span *ngIf="isOptional" class="u-text--sm u-text--grey-blue u-text--normal">(optioneel)</span>

			<tvcore-tooltip *ngIf="labelInfo">
				<p [innerHTML]="labelInfo"></p>
			</tvcore-tooltip>
		</label>
		<span *ngIf="unit" class="c-input__unit">{{ unit }}</span>
		<span *ngIf="type === 'price'" class="c-input__euro">&euro;</span>
		<span #prefixElement *ngIf="prefix" class="c-input__prefix">{{ prefix }}</span>
	</div>

	<ng-template #textArea>
		<div [class.c-input--error]="hasErrors()" [class.c-input--value]="hasValue()" [class.c-input--with-limiter]="maxChar" class="c-input">
			<textarea [formControl]="control" [maxlength]="maxChar || null" [name]="name" [placeholder]="placeholder || ''"></textarea>
			<label [for]="name">{{ label }}</label>
			<p *ngIf="maxChar" [class.c-input__limiter--error]="hasErrors()" class="u-text--sm c-input__limiter">{{ charCount }} / {{ maxChar }}</p>
		</div>
	</ng-template>

	<p *ngIf="example" class="u-text--sm u-text--grey-blue u-m-top--tiny">{{ example }}</p>

	<ng-container *ngIf="showErrors">
		<ng-content></ng-content>
	</ng-container>
</ng-container>
